import axios from '@/plugins/axios';
export function listReply(params) {
  return axios.post('/bidReply/listReply', params);
}
export function chooseReply(params) {
  return axios.post('/bidReply/chooseReply', params);
}
export function saveReply(projectId, supplierUserId, supplierDepartId, quoteStatus) {
  return axios.post('/bidReply/saveReply', {
    projectId: projectId,
    supplierUserId: supplierUserId,
    supplierDepartId: supplierDepartId,
    quoteStatus: quoteStatus
  });
}
export function getReplyById(projectId, supplierUserId) {
  return axios.get('/bidReply/getReplyById', {
    params: {
      projectId: projectId,
      supplierUserId: supplierUserId
    }
  });
}
export function editReply(params) {
  return axios.get('/bidReply/editReply', {
    params: params
  });
}
export function answerOrEditReply(projectId, createId) {
  return axios.get('/bidReply/answerOrEditReply', {
    params: {
      projectId: projectId,
      createId: createId
    }
  });
}
export function openBid(params) {
  return axios.post('/bidReply/openBid', {
    projectId: params.projectId,
    updateId: params.updateId,
    replyId: params.replyId,
    orderNumber: params.orderNumber
  });
}
